
import {  Card, Col, message, Radio, Row, Select, Slider, Space, Statistic, Table, TablePaginationConfig, Tag } from 'antd'
import React, { useEffect, useState } from 'react'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import DragTableRow from 'src/components/DragTableRow'
import usePage from 'src/hooks/usePage'
import {
  getGameUsageChart,
  getGameUsageReportMetrics,
  removeEmptyAttributes,
  searchAdsReport,
  searchGameReport,
} from 'src/api/reports'
import GameUsageReportSearch from './adsReportSearch'

import { useCategoryMap } from 'src/hooks/GamesCategoryContext'
import AreaChart from 'src/components/Charts/AreaChart'
import { chartDateType, deviceMarks, deviceMarksAndroid, mncmccOptions, userType } from 'src/constants'
import { formatTimeWithSuffix } from 'src/utils/numberUtils'
import moment from 'moment'
import HourlyAppUsageChart from 'src/components/Charts/HourlyAppUsageChart'
import { EyeOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { SorterResult, TableCurrentDataSource } from 'antd/lib/table/interface'
import AdsReportSearch from './adsReportSearch'

const { Column } = Table

const AdsReportPage: React.FC = () => {
  const {
    pageData,
    onQuery,
    appendSearchForm,
    appendSearchFormMap,
    submitSearchForm,
    fetchList,
    queryObj,
    searchForm,
  } = usePage({
    getData: searchAdsReport,
    searchData: searchAdsReport,
    searchType: 'POST',
  })
  const { categoryMap, filterGamesByType, findCategoriesForGame } =
    useCategoryMap()
 
  const [loading, setLoading] = useState(true)
  
 
  pageData.data.forEach((gameData) => {
    const categories = findCategoriesForGame(gameData.gameId)
    gameData.categories = categories
  })
  const appUsageChartColor = ['#181c84', '#000000', '#5BB2FF']
  type SortItem = { field: string; order: 'asc' | 'desc' };

const handleTableChange = (
  pagination: TablePaginationConfig,
  _filters: Record<string, (string | number | boolean)[] | null>,
  sorter: SorterResult<any> | SorterResult<any>[],
  extra: TableCurrentDataSource<any>
) => {
  const current = pagination.current ?? 1;
  const pageSize = pagination.pageSize ?? (parseInt(pageData.query.pageSize) || 10);


  const sorterArr = Array.isArray(sorter) ? sorter : [sorter];
  const sorts: SortItem[] = sorterArr
    .filter((s) => s && s.field && s.order)
    .map((s) => ({
      field: String(s.field),
      order: s.order === 'ascend' ? 'asc' : 'desc',
    }));


  if (extra.action === 'paginate') {
    appendSearchForm({ buttonAction: '' });
    onQuery({
      page: String(current - 1),
      pageSize: String(pageSize),
    });
    return;
  }

  
  if (extra.action === 'sort') {
    onQuery({
      page: String(current - 1),
      pageSize: String(pageSize),
      sorts: JSON.stringify(sorts),
    });
    return;
  }

  
  if (extra.action === 'filter') {
    onQuery({
      page: String(current - 1),
      pageSize: String(pageSize),
      sorts: JSON.stringify(sorts),
    });
  }
};

 
  
             const handlePdfClick = () => {
              
              appendSearchForm({ buttonAction: 'Generate Pdf' })
              submitSearchForm()
            }
          
            const handleCsvClick = () => {
               
              appendSearchForm({ buttonAction: 'Generate Csv' })
              submitSearchForm()
            }
             const mncmccMap = Object.fromEntries(
                        mncmccOptions.map(({ value, label }) => [value, label])
                      );
                      const convertedMap: Map<string, string> = new Map(
   
    Array.from(categoryMap.entries()).map(([key, valueSet]) => [
        
        key, 
       
        Array.from(valueSet).join(', ') 
    ])
);
  return (
    <>
      <AdsReportSearch
        appendSearchForm={appendSearchForm}
        submitSearchForm={submitSearchForm}
      />
      
      <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
  <Col>
    <span style={{fontSize:24 }}>
      Search Results ({pageData.total})
    </span>
  </Col>
  <Col>
    <Select
      placeholder="Export"
      style={{ width: 160 }}
      onSelect={(value) => {
        if (value === 'pdf') {
          handlePdfClick();
        } else if (value === 'csv') {
          handleCsvClick();
        }
      }}
      allowClear
    >
      <Select.Option value="pdf">Export as PDF</Select.Option>
      <Select.Option value="csv">Export as CSV</Select.Option>
    </Select>
  </Col>
</Row>
      <DndProvider backend={HTML5Backend}>
        <Table
          className="table-sorting"
          rowKey="eventId"
          dataSource={pageData.data}
          loading={pageData.loading}
          onChange={handleTableChange} 
          pagination={{
            current: parseInt(pageData.query.page) + 1,
            total: pageData.total,
            pageSize: parseInt(pageData.query.pageSize) || 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100'],
           
          }}
        >
          <Column dataIndex="userName" title="Name" sorter={{ multiple: 1 }} />
          <Column dataIndex="gameTitle" title="Game Name" sorter={{ multiple: 3 }} />
          
          
          <Column dataIndex="adsWatched" title="No.of Ads" sorter={{ multiple: 5 }} />
          <Column dataIndex="createdDate" title="created Date" sorter={{ multiple: 5 }} />
         
          <Column dataIndex="providerCountry" title="Country" sorter={{ multiple: 2 }} />
         

          <Column<{ userName: string }>
            title="Action"
            key="url"
            render={(_, record) => (
              <Space size="middle">
                <Link to={`/users/detail/${record.userName}`} className="link-btn">
                  <EyeOutlined />
                </Link>
              </Space>
            )}
          />
        </Table>
      </DndProvider>
    </>
  )
}

AdsReportPage.displayName = 'AdsReportPage'
export default AdsReportPage
